import PropTypes from 'prop-types';
import { formatDistanceToNowStrict } from 'date-fns';
// material
import { styled } from '@material-ui/core/styles';
import { Avatar, Box, Typography, Stack } from '@material-ui/core';
import Link from '@mui/material/Link';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { decodeString } from '../../../utils/decodeString';
import { getFileFormat } from '../../../utils/getFileFormat';
import { Icon } from '@iconify/react';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(3)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 320,
  padding: theme.spacing(1.5),
  marginTop: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.neutral
}));

const InfoStyle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(0.75),
  color: theme.palette.text.secondary
}));

const MessageImgStyle = styled('img')(({ theme }) => ({
  height: "auto",
  // minWidth: 296,
  width: '100%',
  cursor: 'pointer',
  objectFit: 'cover',
  borderRadius: theme.shape.borderRadius
}));

// ----------------------------------------------------------------------

ChatMessageItem.propTypes = {
  itemMess: PropTypes.object.isRequired,
  onOpenLightbox: PropTypes.func
};

export default function ChatMessageItem({ itemMess, onOpenLightbox, ...other }) {
  const { type, message, from_id, to_id, oa_id, from_display_name, from_avatar, to_display_name, to_avatar, url, time, attachment_url_image, attachments, attachment_temp_blob } = itemMess
  const senderDetails =
    from_id === oa_id
      ? { type: 'me' }
      : { avatar: from_avatar, name: from_display_name };
  const isMe = senderDetails.type === 'me';
  const isImage = type === 'photo' || type === 'sticker';

  const firstName = senderDetails.name && senderDetails.name.split(' ')[0];

  return (
    <RootStyle {...other}>
      <Box
        sx={{
          display: 'flex',
          ...(isMe && {
            ml: 'auto'
          })
        }}
      >
        {senderDetails.type !== 'me' && (
          <Avatar alt={senderDetails.avatar} src={senderDetails.avatar} sx={{ width: 32, height: 32 }} />
        )}

        <Box sx={{ ml: 2 }}>
          <InfoStyle noWrap variant="caption" sx={{ ...(isMe && { justifyContent: 'flex-end' }) }}>
            {!isMe && `${firstName},`}&nbsp;
            {formatDistanceToNowStrict(new Date(time), {
              addSuffix: true
            })}
          </InfoStyle>

          <ContentStyle
            sx={{
              ...(isMe && {
                color: 'grey.800',
                bgcolor: 'primary.lighter'
              })
            }}
          >
            {type === "image" ? attachments.map((attachment, index) =>
              <MessageImgStyle key={index} alt="attachment" src={attachment.payload.url} onClick={() => onOpenLightbox(attachment.payload.url)} />)
              : ""}
            {type === "sticker" ? attachments.map((attachment, index) =>
              <MessageImgStyle key={index} alt="attachment" src={attachment.payload.url} onClick={() => onOpenLightbox(attachment.payload.url)} />)
              : ""}
            {type === "file" && Array.isArray(attachments) ? attachments.map((attachment, index) =>
              <Stack direction="row" spacing={0.5}>
                {getFileFormat(decodeString(attachment.payload.name)) === "word" && <Icon width={20} height={20} icon="vscode-icons:file-type-word" />}
                {getFileFormat(decodeString(attachment.payload.name)) === "excel" && <Icon width={20} height={20} icon="vscode-icons:file-type-excel" />}
                {getFileFormat(decodeString(attachment.payload.name)) === "pdf" && <Icon width={20} height={20} color="red" icon="iwwa:file-pdf" />}
                {['word', 'excel', 'pdf'].includes(attachment.payload.name) && <InsertDriveFileIcon ></InsertDriveFileIcon>}
                <Link key={index} alt="attachment" href={attachment.payload.url}>{decodeString(attachment.payload.name)} </Link>
              </Stack>
            )
              : ""}
            {attachment_url_image ? (
              <MessageImgStyle alt="attachment" src={attachment_url_image} onClick={() => onOpenLightbox(attachment_url_image)} />
            ) : ""}
            {attachments && !Array.isArray(attachments) && attachments?.type.search("image") != -1 ? <MessageImgStyle alt="attachment" src={attachment_temp_blob} onClick={() => onOpenLightbox(attachment_temp_blob)} />
              : ""}
            {attachments && !Array.isArray(attachments) && attachments?.type.search("application") != -1 ? <Stack direction="row" spacing={0.5}>
              {getFileFormat(decodeString(attachments.name)) === "word" && <Icon width={20} height={20} icon="vscode-icons:file-type-word" />}
              {getFileFormat(decodeString(attachments.name)) === "excel" && <Icon width={20} height={20} icon="vscode-icons:file-type-excel" />}
              {getFileFormat(decodeString(attachments.name)) === "pdf" && <Icon width={20} height={20} color="red" icon="iwwa:file-pdf" />}
              {!['word', 'excel', 'pdf'].includes(getFileFormat(decodeString(attachments.name))) && <InsertDriveFileIcon ></InsertDriveFileIcon>}
              <Link alt="attachment" href={attachment_temp_blob}>{decodeString(attachments.name)} </Link>
            </Stack>
              : ""}

            <Typography variant="body2">{decodeString(message)}</Typography>

          </ContentStyle>
        </Box>
      </Box>
    </RootStyle>
  );
}
